export const FONT_FAMILY = "'Press Start 2P', monospace";

export const FONT = {
  title: '28px',
  heading: '16px',
  body: '11px',
  small: '9px',
  tiny: '7px',
} as const;

export async function loadPixelFont(): Promise<void> {
  const font = new FontFace('Press Start 2P', `url(${import.meta.env.BASE_URL}assets/fonts/PressStart2P-Regular.ttf)`);
  const loaded = await font.load();
  document.fonts.add(loaded);
}
